<template>

    <StockProductManualFormEmbeddable
        @mounted="onMountedForm"
        @beforeSubmit="onBeforeSubmit"
        @reload="reload()"
        ref="embeddable"
        v-model="form"
        v-if="!mountAgain"
        :enabled-submit="enabledSubmit"
        :fields="fields"
        :source-order-by="sourceOrderBy"
        only-source-exact
        disabled-out-individual-product
    >
      <template #sourceTextNotEnabled>
        Selecione o local de armazenamento para verificar os bags disponíveis em estoque
      </template>
    </StockProductManualFormEmbeddable>

</template>
<script>
import stockProductManualFormEmbeddableMixin from "@/mixins/embeddable/stock/stockProductManualFormEmbeddableMixin";

export default {
  name: 'PolimixStockProductManualForm',
  mixins: [stockProductManualFormEmbeddableMixin],
  data() {
    return {

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      fields: [
        {key: "originCodeLabel", label: "Nº Bag"},
        {key: "productName", label: "Produto"},
        {key: "producedWeight", label: "Peso", formatter: "weightKg"},
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      this.form.quantity = 1
      this.form.stockManualId = 0 //Não especificado tbm
      this.form.stockPlaceProductInsideId = 0 //Padrão será sem nenhum estoque marcado

      await this.$refs.embeddable.getSource()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onBeforeSubmit() {

      //Libera a continuidade sem nenhuma condição especial
      this.enabledSubmit = true
    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>